let loaderStore = null;

export const setLoaderStore = (store) => {
    loaderStore = store;
};

export const getLoaderStore = () => loaderStore;
